import axios from "axios";

export function getApiErrorMessage(err: unknown, fallback: string): string {
  if (axios.isAxiosError(err)) {
    const msg = err.response?.data?.message;
    if (typeof msg === "string" && msg.length > 0) return msg;
  }
  return fallback;
}

/** HTTP status of a failed request; undefined when no answer came back (network error). */
export function apiStatus(err: unknown): number | undefined {
  return (err as { response?: { status?: number } } | null)?.response?.status;
}

/** The machine `code` iam-stc puts in some error bodies (UNDER_AGE, BIRTH_DATE_REQUIRED, CONSENT_REQUIRED, …). */
export function apiErrorCode(err: unknown): string | undefined {
  const code = (err as { response?: { data?: { code?: unknown } } } | null)?.response?.data?.code;
  return typeof code === "string" ? code : undefined;
}

/** Sign-in / registration / refresh refused because the stored or given date of birth is under 14 (403 / 422). */
export function isUnderAgeError(err: unknown): boolean {
  return apiErrorCode(err) === "UNDER_AGE";
}

/** 503: the age check or the legal-site commit was unavailable — nothing happened, the user tries again. */
export function isServiceTryAgain(err: unknown): boolean {
  return apiStatus(err) === 503;
}

/**
 * What may be logged about a failed request: its status and iam's error code, never the error object itself — an
 * axios error carries the request body (`config.data`), which on sign-up / sign-in holds the password and the date
 * of birth.
 */
export function safeError(err: unknown): { status?: number; code?: string; name?: string } {
  const out: { status?: number; code?: string; name?: string } = {};
  const status = apiStatus(err);
  const code = apiErrorCode(err);
  if (status !== undefined) out.status = status;
  if (code !== undefined) out.code = code;
  if (status === undefined && err instanceof Error) out.name = err.name;
  return out;
}
